import { Text } from "@chakra-ui/react";
import React from "react";
import "../App.css";
import "./HeroSection.css";
import UploadImage from "./UploadImage";
import { useAuth } from "./contexts/AuthContext";

function HeroSection() {
  var { currentUser } = useAuth();

  return (
    <div className="hero-container">
      {/* <div className="hero-btns"></div>
      {currentUser && <Text my={6}>{`Hello ${currentUser.email}!`}</Text>}
      {currentUser && <Text color="tomato">Upload a meme:</Text>}
      {currentUser && <UploadImage />} */}
    </div>
  );
}

export default HeroSection;
